'use client';

import dynamic from 'next/dynamic';
import { FC, useState } from 'react';

import { Button } from '@/general/components/Button/Button';

const CarEnquiryFormModal = dynamic(
  () => import('@/pdp/components/CarEnquiryForm/CarEnquiryFormModal').then((mod) => mod.CarEnquiryFormModal),
  { ssr: false },
);

type Props = {
  buttonLabel: string;
};

export const OptInForm: FC<Props> = ({ buttonLabel }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onOpen = () => {
    setIsOpen(true);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <footer className="OptInSection-footer">
        <Button onClick={onOpen}>{buttonLabel}</Button>
      </footer>

      <CarEnquiryFormModal isOpen={isOpen} onClose={onClose} />
    </>
  );
};
